export const REACTION_TRANSLATION = {
  search: 'Suche',
  categories: {
    search: 'Suchergebnisse',
    recent: 'Zuletzt verwendet',
    smileys: 'Smileys & Emotionen',
    people: 'Menschen & Körper',
    nature: 'Tiere & Natur',
    foods: 'Essen & Trinken',
    activity: 'Aktivitäten',
    places: 'Reisen & Orte',
    objects: 'Objekte',
    symbols: 'Symbole',
    flags: 'Flaggen'
  },
  notfound: 'Keine Emojis gefunden'
};
